import { LiveSessionStatus } from '@utils/types/editors/live-transcript.ts';

export const liveTranscriptStatusKey = (
  loading: boolean,
  owner: LiveSessionStatus | null,
  connected: boolean
) => {
  if (loading) return 'loading';
  if (owner?.state === 'failed') return 'live-ingestion-failed';
  if (owner?.state === 'stopped') return 'live-stopped';
  return connected ? 'live-transcribing' : 'live-reconnecting';
};
